module.exports = __webpack_public_path__ + "static/media/step_hold_nfts.53f0c8ed.png";